var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "", placeholder: "赛区" },
                  model: {
                    value: _vm.paramsData.division_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "division_id", $$v)
                    },
                    expression: "paramsData.division_id"
                  }
                },
                _vm._l(_vm.divisionAllList, function(item) {
                  return _c("el-option", {
                    key: item.name,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "", placeholder: "状态" },
                  model: {
                    value: _vm.paramsData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "status", $$v)
                    },
                    expression: "paramsData.status"
                  }
                },
                _vm._l(_vm.statusList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-date-picker", {
                attrs: {
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间"
                },
                on: { change: _vm.datechange },
                model: {
                  value: _vm.value2,
                  callback: function($$v) {
                    _vm.value2 = $$v
                  },
                  expression: "value2"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addDivisionCore.init()
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" }
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "赛事描述" }
          }),
          _c("el-table-column", {
            attrs: { prop: "vip_level_required", label: "VIP等级" }
          }),
          _c("el-table-column", {
            attrs: { prop: "division_name", label: "赛区名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "reward_name", label: "奖励分组名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "start_time", label: "开始时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "end_time", label: "结束时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "capacity", label: "比赛设备" }
          }),
          _c("el-table-column", {
            attrs: { prop: "participant_count", label: "比赛人数" }
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0 ? _c("span", [_vm._v("未开始")]) : _vm._e(),
                    row.status == 1 ? _c("span", [_vm._v("进行中")]) : _vm._e(),
                    row.status == 2
                      ? _c("span", [_vm._v("已结束待结算")])
                      : _vm._e(),
                    row.status == 3 ? _c("span", [_vm._v("已结算")]) : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "260",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      scope.row.status != 3
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.addDivisionCore.init(
                                    scope.row
                                  )
                                }
                              }
                            },
                            [_vm._v(" 修改 ")]
                          )
                        : _vm._e(),
                      scope.row.status != 3
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e(),
                      scope.row.status != 3
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(scope.row.id)
                                }
                              }
                            },
                            [_vm._v(" 删除 ")]
                          )
                        : _vm._e(),
                      scope.row.status != 3
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleMange(scope.row)
                            }
                          }
                        },
                        [_vm._v(" 管理 ")]
                      ),
                      scope.row.status == 1
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e(),
                      scope.row.status == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.advanceOver(scope.row.id)
                                }
                              }
                            },
                            [_vm._v(" 提前手动结束 ")]
                          )
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total
            },
            on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
          })
        : _vm._e(),
      _c("addDivisionCore", {
        ref: "addDivisionCore",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }